import React, { createContext, useState, useContext } from 'react';

import { IAmodeContextData } from './interface';

const IAModeContext = createContext<IAmodeContextData>(
  {} as IAmodeContextData,
);

export const IAmodeProvider: React.FC = ({ children }) => {
  const [enable, setEnable] = useState<boolean>(() => {
    const data = localStorage.getItem('@commerceplus_dashboard:iamode');
    const _enable = data === 'true' ? true : false;
    return _enable;
  });

  const toggleIAmode = () => {
    const _enable = !enable;
    localStorage.setItem('@commerceplus_dashboard:iamode', `${_enable}`);
    setEnable(_enable);
  };

  return (
    <IAModeContext.Provider value={{ enable, toggleIAmode }}>
      {children}
    </IAModeContext.Provider>
  );
};

export function useIAmode(): IAmodeContextData {
  const context = useContext(IAModeContext);
  if (!context) {
    throw new Error('hook usado fora do contexto do IAmode!');
  }
  return context;
}
